module.exports = __webpack_public_path__ + "media/images/icons/payment_methods/Klarna-fa255fa9acd7f1e4e45115a039281a03.svg";